import { render, staticRenderFns } from "./QuickAccessCards.vue?vue&type=template&id=8b59f726&"
import script from "./QuickAccessCards.vue?vue&type=script&lang=js&"
export * from "./QuickAccessCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports